export const currencyByLocale = {
  // Europa
  'es-ES': 'EUR',

  // América do Norte
  'en-US': 'USD',
  'en-CA': 'CAD',
  'es-MX': 'MXN',

  // América Central
  'en-BZ': 'BZD',
  'es-CR': 'CRC',
  'es-SV': 'USD',
  'es-GT': 'GTQ',
  'es-HN': 'HNL',
  'es-NI': 'NIO',
  'es-PA': 'PAB',

  // Caribe
  'en-AG': 'XCD',
  'en-DM': 'XCD',
  'en-GD': 'XCD',
  'en-KN': 'XCD',
  'en-LC': 'XCD',
  'en-VC': 'XCD',
  'en-BS': 'BSD',
  'en-BB': 'BBD',
  'es-CU': 'CUP',
  'es-DO': 'DOP',
  'fr-HT': 'HTG',
  'en-JM': 'JMD',
  'en-TT': 'TTD',

  // América do Sul
  'es-AR': 'ARS',
  'es-BO': 'BOB',
  'pt-BR': 'BRL',
  'es-CL': 'CLP',
  'es-CO': 'COP',
  'es-EC': 'USD',
  'en-GY': 'GYD',
  'es-PY': 'PYG',
  'es-PE': 'PEN',
  'nl-SR': 'SRD',
  'es-UY': 'UYU',
  'es-VE': 'VES',
}
